export default __webpack_public_path__ + "static/media/img3.af1a7c68.png";